export default "__VITE_ASSET__3956d53d__"